'use strict';

;
(function ($) {

  $('.gallery__item').magnificPopup({
    type: 'image'
  });

  $('.record-btn').magnificPopup({
    type: 'inline',
    callbacks: {
      open: function open() {
        Bnovo_Widget.init(function () {
          Bnovo_Widget.open('_bn_widget_', {
            type: "vertical",
            lcode: "1461920712",
            lang: "ru",
            width: "400",
            background: "#ffffff",
            bg_alpha: "75",
            padding: "18",
            font_size: "12",
            btn_background: "#ffd494",
            btn_background_over: "#dfb270",
            btn_textcolor: "#FFFFFF",
            btn_textover: "#FFFFFF"
          });
        });
      }
    }
  });

  $('.gallery').slick({
    lazyLoad: 'ondemand',
    slide: '.gallery__item',
    useTransform: true
  });

  $(document).on('click', '.js-gallery-goto', function () {
    var $this = $(this);
    $('.gallery-nav__item').removeClass('active');
    $this.addClass('active');
    $('.gallery').slick('slickGoTo', $this.index(), true);
    $('.gallery').velocity("scroll", { offset: -80 });
  }).on('click', '.js-accord', function () {
    var $this = $(this);

    $this.toggleClass('hide');
    $this.next('.content').stop().slideToggle();
  });

  // $('.gallery-nav').slick({
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   useTransform: true,
  //   asNavFor: '.gallery',
  //   arrows: false,
  //   centerMode: true,
  //   centerPadding: 0,
  //   focusOnSelect: true
  // });

  if ($('#map').length) {
    var init = function init() {
      var $map = $('#map'),
          placemark = $map.data('placemark'),
          center = $map.data('center');

      map = new ymaps.Map("map", {
        center: center,
        zoom: 17
      });

      map.behaviors.disable('scrollZoom');

      var addr = $map.data('addr');

      var marker = ymaps.templateLayoutFactory.createClass('<div class="map-marker"></div>');

      var coord = [[-87, -60], [87, 60]];

      var squarePlacemark = new ymaps.Placemark(placemark, {
        hintContent: ''
      }, {
        iconLayout: marker,
        iconShape: {
          type: 'Rectangle',
          coordinates: coord
        }
      });
      map.geoObjects.add(squarePlacemark);
    };

    ymaps.ready(init);
    var map;
  }
})(jQuery);